import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Decorative } from "@faire/design-tokens";
import { Section, SectionHeadline, LimitedSectionContent } from "@faire/retailer-visitor-shared/views/careers/__internal__/common/common";
import { Flex } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import styled from "styled-components";
export var BelongingEmployeesCustomersSection = function() {
    return /*#__PURE__*/ _jsx(Section, {
        $backgroundColor: Decorative.tint.neutral,
        $withHorizontalPadding: true,
        $withVerticalPadding: true,
        align: "center",
        children: /*#__PURE__*/ _jsxs(LimitedSectionContent, {
            children: [
                /*#__PURE__*/ _jsxs(RowToColumn, {
                    children: [
                        /*#__PURE__*/ _jsx(HeadlineContainer, {
                            children: /*#__PURE__*/ _jsx(SectionHeadline, {
                                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                    id: "Cz+Ok/",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "For our employees"
                                        }
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsx(Spacer, {
                            height: {
                                mobileAndAbove: "3x",
                                desktopAndAbove: 0
                            }
                        }),
                        /*#__PURE__*/ _jsx(BodyContainer, {
                            children: /*#__PURE__*/ _jsx(Typography, {
                                variant: {
                                    mobileAndAbove: "paragraphSansRegular",
                                    desktopAndAbove: "subheadingSansRegular"
                                },
                                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                    id: "C/4HRA",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "An inclusive work environment ensures that all Faire employees feel valued and have equal access to opportunities, professional growth, and success. We're committed to fostering a culture where all Faire employees can show up authentically and learn from one another through active listening."
                                        }
                                    ]
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "8x"
                }),
                /*#__PURE__*/ _jsxs(RowToColumn, {
                    children: [
                        /*#__PURE__*/ _jsx(HeadlineContainer, {
                            children: /*#__PURE__*/ _jsx(SectionHeadline, {
                                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                    id: "LeMwmW",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "For our customers"
                                        }
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsx(Spacer, {
                            height: {
                                mobileAndAbove: "3x",
                                desktopAndAbove: 0
                            }
                        }),
                        /*#__PURE__*/ _jsx(BodyContainer, {
                            children: /*#__PURE__*/ _jsx(Typography, {
                                variant: {
                                    mobileAndAbove: "paragraphSansRegular",
                                    desktopAndAbove: "subheadingSansRegular"
                                },
                                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                    id: "snO6/e",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "As a global platform, we recognize that our product serves a diverse community of brands and retailers. That\u2019s why we take a localized approach when entering new markets, and are committed to amplifying unique voices across our site through collection features, blog spotlights, and customer panels."
                                        }
                                    ]
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var RowToColumn = styled(Flex).attrs({
    direction: {
        mobileAndAbove: "column",
        desktopAndAbove: "row"
    }
}).withConfig({
    componentId: "sc-abd91ac8-0"
})([
    ""
]);
var HeadlineContainer = styled.div.withConfig({
    componentId: "sc-abd91ac8-1"
})([
    "width:400px;min-width:350px;"
]);
var BodyContainer = styled.div.withConfig({
    componentId: "sc-abd91ac8-2"
})([
    "max-width:571px;"
]);
